import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CoreCurrencyService {
  private currency: string | null = null;

  public setSelectedCurrency(value: string): void {
    this.currency = value;

    sessionStorage.setItem('currency', value);
  }

  public getSelectedCurrency(): string | null {
    const selectedValue = this.currency;

    if (!selectedValue && sessionStorage.getItem('currency')) {
      return sessionStorage.getItem('currency') as string;
    }

    return this.currency;
  }
}
